import { useMutation, useQueryClient } from '@tanstack/react-query';

import { EventStatus } from '@/interfaces/entities/event';
import { eventService } from '@/services/event.service';
import { notificationService } from '@/services/notification.service';

const useChangeEventStatus = () => {
	const queryClient = useQueryClient();
	return useMutation({
		mutationFn: async ({
			eventId,
			status,
		}: {
			eventId: number;
			status: EventStatus;
		}) => await eventService.changeStatus(eventId, status),
		onSuccess: () => {
			notificationService.success('Event status changed successfully');
			queryClient.invalidateQueries({ queryKey: ['event'] });
		},
	});
};

export default useChangeEventStatus;
